import { render } from "./LowerThirds.vue?vue&type=template&id=051e1066&scoped=true"
import script from "./LowerThirds.vue?vue&type=script&lang=js"
export * from "./LowerThirds.vue?vue&type=script&lang=js"

import "./LowerThirds.vue?vue&type=style&index=0&id=051e1066&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051e1066"]])

export default __exports__